module.exports = __webpack_public_path__ + "img/ebay.9d72c12a.png";